import React, { useState, useEffect } from 'react'
import { ReactComponent as ChevronDownDuoIcon } from '../../../assets/svg/ChevronDownDuoIcon.svg'
import { ReactComponent as SchoolAverageIcon } from '../../../assets/svg/SchoolAverageIcon.svg'
import { ReactComponent as UserCardId } from '../../../assets/svg/UserCardId.svg'
import ExpandButton from '../../common/ExpandButton'
import { useTranslation } from 'react-i18next'
import { useUser } from '../../../auth'
import InfoButton from '../../common/InfoButton'
import { alertsData } from './mocks/AlertsData'
import { LoadingContainer } from '../student/CheckInWidget'
import { Link } from 'react-router-dom'
import { loadCounsellorAlerts } from '../../../server/server'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const SHOW_ROWS = 3

function CounsellorAlertsWidget({ daysFilter, selectedOptions, isCounsellor }) {
    const { t } = useTranslation()

    const [limit, setLimit] = useState(SHOW_ROWS)
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(alertsData)
    const [noData, setNoData] = useState(false)

    useEffect(() => {
        setLoading(true)
        loadData()
    }, [daysFilter, selectedOptions])

    const loadData = async () => {
        const resp = await loadCounsellorAlerts(selectedOptions, daysFilter.startDate, daysFilter.endDate)
        if (resp.status === 200) {
            setData(resp.data)
            setLoading(false)

            setLimit(SHOW_ROWS)
            // setHasMore(resp?.data?.years?.length > SHOW_ROWS)
        }
    }

    const selectAssignedSort = (sort) => {
        setLoading(true)
        loadData(sort)
    }

    return (
        <div className="bg-white rounded-[24px] p-5 mt-4" data-tour="alerts">
            <div className=" flex flex-row items-center justify-between">
                <div className="flex flex-row items-center gap-2">
                    <p className="text-[18px] leading-[25px] font-medium text-darkenPurple ">{t('Alerts for selected student groups')}</p>
                    <div className="flex items-center justify-center rounded-full bg-[#413F5E14] h-6 px-[10px]">
                        <p className="text-[13px] leading-[18px] font-normal text-strongGray ">{t(daysFilter.label)}</p>
                    </div>
                </div>
                <div className="flex items-center gap-4">
                    <button>
                        <InfoButton color="#5E639B" text={t('View all keyword and emotion alerts for selected year groups.')} />
                    </button>
                    {/* <AssignFilter selectedFilter={selectedSortOrder} setSelectedFilter={selectAssignedSort} list={alertsSortList} contentListMap={alertsSortListMap} width={215} /> */}
                </div>
            </div>
            <div className="relative mt-4">
                <DataContainer data={data} blur={false} maxSize={limit} limit={limit} setLimit={setLimit} selectedOptions={selectedOptions} />
                {false && <LoadingContainer showEmptyData={noData} />}
            </div>
        </div>
    )
}

export default CounsellorAlertsWidget

const DataContainer = ({ data = [], blur, limit, setLimit }) => {
    const { t } = useTranslation()

    const handleShowMore = () => {
        if (limit === SHOW_ROWS) {
            setLimit(data?.years?.length)
        } else {
            setLimit(SHOW_ROWS)
        }
    }

    return (
        <div className={` ${blur ? 'blur' : ''} `}>
            <div className="w-full relative flex flex-col gap-3 mt-4">
                <SingleItem data={data} isClass={false} />
                {data?.years.slice(0, limit).map((item, index) => {
                    return <SingleItem data={data} key={index} item={item} index={index} limit={limit} />
                })}
            </div>
            <div className="flex flex-row justify-end w-full mt-4">
                {!blur && data?.years?.length > SHOW_ROWS && (
                    <button
                        className="flex flex-row items-center justify-center gap-2 border border-[#ECEBF8] hover:border-darkenPurple transition rounded-full h-[34px] px-4 bg-[#F8F8FB]"
                        onClick={() => handleShowMore()}
                        disabled={blur || (!blur && !data)}
                    >
                        <p className="text-darkenPurple text-[16px] leading-5 font-semibold">{limit > SHOW_ROWS ? t('See less years') : t('See all years')}</p>
                        <div className={`${limit > SHOW_ROWS ? 'rotate-180' : 'rotate-0'} transition`}>
                            <ChevronDownDuoIcon />
                        </div>
                    </button>
                )}
            </div>
        </div>
    )
}

const SingleItem = ({ data, item, index, isClass = true, limit }) => {
    const [open, setOpen] = useState(false)
    const { t } = useTranslation()

    const isLastItem = index + 1 === data?.years?.slice(0, limit).length

    const schoolText = isClass ? (
        <p className="text-[14px] leading-[20px] font-medium text-darkenPurple ">
            {t('Year')} {item?.year} {' - '}
            <span className="text-[#FC4C59] font-semibold">
                {item?.alerts} {item?.alerts > 1 ? t('alerts') : t('alert')}
            </span>{' '}
        </p>
    ) : (
        <p className="text-[14px] leading-[20px] font-medium text-darkenPurple ">
            {t('Whole school')} {' - '}
            <span className="text-[#FC4C59] font-semibold">
                {data?.school} {data?.school > 1 ? t('alerts') : t('alert')}
            </span>{' '}
        </p>
    )
    return (
        <div className={`flex flex-col gap-[10px] ${isLastItem ? '' : ' pb-3 border-b border-b-[#E8E0FF]'}`} data-tour="">
            <div className="flex flex-col gap-[10px]" style={{ backgroundColor: isClass ? 'transparent' : 'white' }}>
                <div className={`flex-1  rounded-[4px] ${isClass ? ' p-2 bg-[#F8F8FB]' : 'pl-2'}`}>
                    <div className="flex-1 flex flex-row items-center gap-[10px] ">
                        <div className="flex flex-row  items-center gap-1 flex-1">
                            <div className="min-w-7 max-w-7 h-7 rounded-full bg-[#B8B8D6] flex items-center justify-center">
                                {isClass ? (
                                    <p className="text-[12px] leading-[20px] font-medium text-[#000000] ">{!!item?.year ? 'Y' + item?.year[0] : 'Y'}</p>
                                ) : (
                                    <SchoolAverageIcon />
                                )}
                            </div>
                            {schoolText}
                        </div>
                        <div className="">
                            {isClass && (
                                <ExpandButton
                                    open={open}
                                    onClick={() => {
                                        setOpen((prev) => !prev)
                                    }}
                                    width={24}
                                    height={24}
                                />
                            )}
                        </div>
                    </div>
                    <div className={`overflow-hidden transition-all  ${open ? 'max-h-[1000px] h-auto' : 'max-h-0'} ${open ? 'opacity-100 mt-[11px]' : 'opacity-0'}`}>
                        <div className="flex flex-col gap-[6px]">
                            {item?.classes?.map((classItem, index) => (
                                <SingleClassItem classItem={classItem} key={index} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const SingleClassItem = ({ classItem, schoolPercentage, yearPercentage }) => {
    const { t } = useTranslation()
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const daysCode = params.get('days')
    return (
        <div className="flex flex-row items-center gap-10 p-2 bg-white rounded-[4px]">
            <div className="flex flex-col gap-1 flex-1">
                <div className="flex flex-col  gap-1">
                    <p className="text-[#413F5E] font-medium text-[13px] leading-[18px]">{classItem?.name}</p>
                    <p className="text-[#FC4C59] font-medium text-[13px] leading-[13px]">
                        {classItem?.alerts} {classItem?.alerts > 1 ? t('alerts') : t('alert')}
                    </p>
                </div>
            </div>
            <Link to={`/analytics/class?id=${classItem?.id}&days=${daysCode}`} className="flex items-center justify-center  h-[36px] rounded-full bg-[#86D3FF33] px-4 gap-1">
                <UserCardId />
                <p className="text-[#413F5E] font-normal text-[14px] leading-5">{t('See Class Analytics')}</p>
            </Link>
        </div>
    )
}
